import React from "react";
import { withRouter } from "react-router-dom";
import LoadSpinner from "../../../common/spinner/loadSpinner";
import Menucustom from "../../../common/menu/menucustom";
import DashboardAreeService from "./dashboardAreeService";
import { Form, InputGroup } from "react-bootstrap";
import { BsFillCircleFill } from "react-icons/bs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NumberFormat from "react-number-format";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  getColorState,
} from "../../../common/utils";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { CSVLink, CSVDownload } from "react-csv";
import ingiunzioniList from "../../../common/mookup/MookUpIngunzioni";
import { Modal, Button, Row } from "react-bootstrap";
toast.configure();

class Linee extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      aree: [
        {
          idArea: 0,
          nomeArea: "",
          idCliente: "",
          statobottne: true,
        },
      ],
      abilitazioneDiModificaSuUnLinea: [], //è un array di chiavi per abilitare e disabilitare un bottone di un area
      loading: true,
      abilitaModificaLinea: [],
      eliminaModal: false,
      idDaEliminare: 0,
      AggiungiUnaLinea: false,
      nomeArea: "",
      loadingButton:false,
    };
    this.geDataFormat = geDataFormat.bind(this);
    this.getColorState = getColorState.bind(this);
    // this.onRowClick = this.onRowClick.bind(this);
  }

  componentDidMount() {
    this.dashboardAreeService = new DashboardAreeService();

    this.dashboardAreeService.getDataTableLenee((Linee) => {
      Linee.data.map((aree) => {
        aree.statobottne = true;
        aree.bottoniEditi = true;
      });
      this.setState({ aree: Linee.data });
    });
    this.setState({ loading: false });
  }

  onChangeNomelineea(event) {
    const idInput = event.target.id;
    this.state.aree[idInput].nomeArea = event.target.value;
    this.setState({ aree: this.state.aree });
  }

  annullaElimina() {
    this.setState({ eliminaModal: false });
  }

  confremaElimna() {
    this.setState({loadingButton:true})
    this.dashboardAreeService.deleteLinea(
      this.state.idDaEliminare,
      (result) => {
        this.setState({loadingButton:false})
        if (result.status === 200) {
          toast.success("Eliminato con successo");
        } else {
          toast.error("Qualcosa è andato storto");
        }
        this.dashboardAreeService.getDataTableLenee((Linee) => {
          Linee.data.map((aree) => {
            aree.statobottne = true;
            aree.bottoniEditi = true;
          });
          this.setState({ aree: Linee.data, eliminaModal: false });
        });
      }
    );
  }

  eliminaModal() {
    return (
      <>
        <Modal size="sm" show={this.state.eliminaModal}>
          <Modal.Header>
            <Modal.Title>Elimina Area</Modal.Title>
          </Modal.Header>
          <Modal.Body>Sei sicuro di eliminare la Area?</Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.annullaElimina.bind(this)}
            >
              Annulla
            </Button>
            <Button variant="danger" disabled={this.state.loadingButton} onClick={this.confremaElimna.bind(this)}>
              {this.state.loadingButton ? <LoadSpinner/> : "Elimina Area"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  annullaAggiungi() {
    this.setState({ AggiungiUnaLinea: false, nomeArea: "" });
  }

  confremaAggiungi() {
    this.nuovaLinea = {
      nomeArea: this.state.nomeArea,
    };
    this.setState({loadingButton:true})
    this.dashboardAreeService.insertLinea(this.nuovaLinea, (result) => {
      this.setState({loadingButton:false})
      if (result.status === 200) {
        toast.success("Area aggiunta con successo");
      } else {
        toast.error("Qualcosa è andato storto");
      }

      this.dashboardAreeService.getDataTableLenee((Linee) => {
        Linee.data.map((aree) => {
          aree.statobottne = true;
          aree.bottoniEditi = true;
        });
        this.setState({
          aree: Linee.data,
          AggiungiUnaLinea: false,
          nomeArea: "",
        });
      });
    });
  }

  onChangeNuovaLinea(event) {
    this.state.nomeArea = event.target.value;
    this.setState({ nomeArea: this.state.nomeArea });
  }

  AggiungiUnaLinea() {
    return (
      <>
        <Modal size="lg" show={this.state.AggiungiUnaLinea}>
          <Modal.Header>
            <Modal.Title>Aggiungi una nuova Area</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <label>Nome Area</label>
            <input
              className="form-control"
              type="text"
              value={this.state.nomeArea}
              onChange={this.onChangeNuovaLinea.bind(this)}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={this.annullaAggiungi.bind(this)}
            >
              Annulla
            </Button>
            <Button
              variant="primary"
              disabled={this.state.loadingButton || this.state.nomeArea.length < 3}
              onClick={this.confremaAggiungi.bind(this)}
            >
             {this.state.loadingButton ? <LoadSpinner/> : "Aggiungi Area"}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  tabellaAree() {
    return (
      <>
        <table class="table table-bordered text-center">
          <thead>
            <tr>
              <th scope="col">Nome Area</th>
              <th scope="col">Azioni</th>
            </tr>
          </thead>
          <tbody>
            {this.state.aree.map((aree, index) => {
              return (
                <>
                  <tr>
                    <th>
                      <input
                        id={index}
                        disabled={aree.statobottne}
                        className="form-control"
                        type="text"
                        value={aree.nomeArea}
                        onChange={this.onChangeNomelineea.bind(this)}
                      />
                    </th>
                    <td>
                      {aree.bottoniEditi ? (
                        <>
                          <button
                            className="btn btn-primary"
                            onClick={() => {
                              this.dashboardAreeService.getDataTableLenee(
                                (Linee) => {
                                  Linee.data.map((aree, indeds) => {
                                    if (indeds === index) {
                                      aree.statobottne = false;
                                      aree.bottoniEditi = false;
                                    } else {
                                      aree.statobottne = true;
                                      aree.bottoniEditi = true;
                                    }
                                  });

                                  //   console.log(Linee);
                                  this.setState({ aree: Linee.data });
                                }
                              );
                              this.setState({ loading: false });
                            }}
                          >
                            {" "}
                            <i className="fas fa-fw fa-edit"></i>{" "}
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-danger"
                            onClick={() =>
                              this.setState({
                                eliminaModal: true,
                                idDaEliminare: this.state.aree[index].idArea,
                              })
                            }
                          >
                            {" "}
                            <i className="fas fa-fw fa-trash"></i>{" "}
                          </button>
                          &nbsp;
                        </>
                      ) : (
                        <>
                          <button
                            className="btn btn-success"
                            disabled={this.state.loadingButton}
                            onClick={() => {
                              //   console.log(this.state.aree[index]);

                              this.lineaEdit = {
                                idArea: this.state.aree[index].idArea,
                                nomeArea: this.state.aree[index].nomeArea,
                                idCliente: this.state.aree[index].idCliente,
                              };
                              this.setState({loadingButton:true})
                              this.dashboardAreeService.salvaModifica(
                                this.lineaEdit,
                                (result) => {
                                  this.setState({loadingButton:false})
                                  if (result.status === 200) {
                                    toast.success("Area Aggiornata");
                                  } else {
                                    toast.error("Area non Aggiornata");
                                  }
                                  this.dashboardAreeService.getDataTableLenee(
                                    (Linee) => {
                                      Linee.data.map((aree) => {
                                        aree.statobottne = true;
                                        aree.bottoniEditi = true;
                                      });
                                      this.setState({ aree: Linee.data });
                                    }
                                  );
                                }
                              );
                            }}
                          >
                            {" "}
                            {this.state.loadingButton ? <LoadSpinner/> : <i className="fas fa-fw fa-check"></i>}
                            {" "}
                          </button>
                          &nbsp;
                          <button
                            className="btn btn-danger"
                            id={index}
                            onClick={() => {
                              this.dashboardAreeService.getDataTableLenee(
                                (Linee) => {
                                  Linee.data.map((aree, indeds) => {
                                    if (indeds === index) {
                                      aree.statobottne = true;
                                      aree.bottoniEditi = true;
                                    } else {
                                      aree.statobottne = true;
                                      aree.bottoniEditi = true;
                                    }
                                  });
                                  this.setState({ aree: Linee.data });
                                }
                              );
                              this.setState({ loading: false });
                            }}
                          >
                            {" "}
                            <i className="fas fa-fw fa-times"></i>{" "}
                          </button>
                          &nbsp;
                        </>
                      )}
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
      </>
    );
  }
  render() {
    // console.log(this.state.aree);
    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <div id="wrapper">
        <Menucustom />
        <div className="container-fluid">
          <br />
          <br />
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h1 mb-2 text-gray-800">
              Gestione Area<br></br>
            </h1>
            {/* <small
                style={{ fontSize: "14px" }}
                className="mb-2 text-gray-800"
              > 
                Aree &#8594; In Lavorazione
              </small>< */}

            <button
              type="button"
              class="btn btn-warning"
              onClick={() => {
                this.setState({ AggiungiUnaLinea: true });
              }}
            >
              {" "}
              <i className="fas fa-plus fa-sm text-white"></i> &nbsp;Aggiungi
              una nuova Area
            </button>
            <a className=""></a>
          </div>
          <br />
          <br />
          <div className="col">{this.tabellaAree()}</div>
          {this.eliminaModal()}
          {this.AggiungiUnaLinea()}
        </div>
      </div>
    );
    return <div>{content}</div>;
  }
}
export default withRouter(Linee);
